import { render } from "./wEditor.vue?vue&type=template&id=d423b120&ts=true"
import script from "./wEditor.vue?vue&type=script&lang=ts"
export * from "./wEditor.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__